import { getApps } from "@/api/home";

export const mixins = {
  data() {
    return {
      list: [],
      imgCdn: "",
    };
  },
  created() {
    this.getAppList();
  },
  methods: {
    async getAppList() {
      try {
        let appIds = [];
        if (this.$route.query.s) {
          appIds = this.$route.query.s.split("_");
        }
        let res = await getApps();
        if (res.code == 200) {
          this.imgCdn = res.data.imgCdn;
          const apps = res.data.list || [];
          if (apps.length) {
            this.list = apps
              .map((item) => {
                let index = appIds.findIndex((appId) => appId == item.appId);
                if (index != -1) {
                  return item;
                }
              })
              .filter((item) => item);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    jump(item) {
      if (this.$route.query.dc) {
        window.open(`${item.landPages[0]}?dc=${this.$route.query.dc}`);
      } else {
        window.open(item.landPages[0]);
      }
    },
    jumpUrl(url) {
      window.open(url);
    },
  },
};
